import {Chip, Link, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import Box from "@mui/material/Box";
import {Service} from "../../service";
import {HostnamesAsLinks} from "../hostnames";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import SettingsIcon from "@mui/icons-material/Settings";
import React from "react";
import {IngressSummary} from "../ingresses";
import {collapseWebsiteRows} from "./mergeWebsites";

interface FullProps {
    ingressesData: Array<IngressSummary>
}
export const Full = (props: FullProps): React.JSX.Element => {
    const siteRows = collapseWebsiteRows(props.ingressesData);

    return (
        <TableContainer sx={{ width: "100%", overflowX: "hidden" }}>
            <Table sx={{ width: "100%", tableLayout: "fixed", margin: "0 auto", background: "white" }} aria-label="ingresses">
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ width: "28%" }}>Service / ID</TableCell>
                        <TableCell sx={{ width: "42%" }}>Hostnames</TableCell>
                        <TableCell sx={{ width: "18%" }}>Created</TableCell>
                        <TableCell sx={{ width: "12%" }}>Configure</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {siteRows.map((ing) => (
                        <TableRow key={`${ing.service}-${ing.id}`} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                            <TableCell component="th" scope="row" sx={{ verticalAlign: "top" }}>
                                <Box display="flex" alignItems="center" flexWrap="wrap" gap={0.5} sx={{ minWidth: 0 }}>
                                    <Box display="flex" alignItems="center" gap={1} sx={{ minWidth: 0 }}>
                                        <Service service={ing.service} />
                                        <Box sx={{ overflowWrap: "anywhere" }}>{ing.id}</Box>
                                    </Box>
                                    {ing.isProd && (
                                        <Chip label="Production" size="small" color="primary" />
                                    )}
                                </Box>
                            </TableCell>
                            <TableCell sx={{ verticalAlign: "top" }}><HostnamesAsLinks hostnames={ing.hostnames} /></TableCell>
                            <TableCell sx={{ verticalAlign: "top", overflowWrap: "anywhere" }}>{ing.created}</TableCell>
                            <TableCell align="center" sx={{ verticalAlign: "top" }}>
                                <Tooltip title={`Configure ${ing.id}`}>
                                    <Link href={`/sites/${ing.id}`}>
                                        <IconButton color="primary" aria-label="configure site" component="label">
                                            <SettingsIcon />
                                        </IconButton>
                                    </Link>
                                </Tooltip>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}
